import { render, staticRenderFns } from "./OpenAwardConfigurationTab.vue?vue&type=template&id=2eab7347&scoped=true&"
import script from "./OpenAwardConfigurationTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./OpenAwardConfigurationTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OpenAwardConfigurationTab.vue?vue&type=style&index=0&id=2eab7347&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eab7347",
  null
  
)

export default component.exports